import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  effect,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

import * as joint from 'jointjs';
import svgPanZoom from 'svg-pan-zoom';
import { NodeModel } from './model/node.model';
import { DEFAULT_NODES, PAPER_CONFIG, ZOOM_CONFIG } from './config/constants';

import { CreateNewNodesService } from './services/create-new-nodes.service';
import { MonitoringTooltip } from './services/create-monitoring-template.service';

import * as helper from './helpers';
import {
  InvalidNodeTypeError,
  NodeNotFoundError,
} from '@modules/campaigns/Domain/Errors/WorkflowErrors';
import { ToastService } from '@services/ui';
import { NodeFactory } from '@modules/campaigns/Domain/Factories/NodeFactory';
import { NodeClass } from '@modules/campaigns/Domain/NodeClass';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { WorkflowClass } from '@modules/campaigns/Domain/WorkflowClass';
import { hascopyIds } from '@modules/campaigns/Domain/Factories/HasNodeConfig';
import { ConditionalConfig } from '@modules/campaigns/Domain/Interfaces/INodeConfig';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { WorkflowType } from '@modules/campaigns/Domain/Enums/WorkflowType';
import { CopyModel } from '@models/copies/copies.model';
import { WorkflowInstance } from '@modules/customer-case-campaings-instances/Model/workflow-insitance.model';
import { Router } from '@angular/router';
import { BranchVisibilityService } from '@shared/components/joint-js/services/branch-visibility-service';
import { EventNode, WorkflowStateService } from '@shared/state/workflow-state.service';
import { NodeInspectorRegistry } from '@shared/state/node-inspector-registry.service';

@Component({
  selector: 'app-joint-js',
  templateUrl: './joint-js.component.html',
  styleUrls: ['./joint-js.component.scss'],
})
export class JointJsComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @Output() nodesReady = new EventEmitter<any>();

  @Input() isEditable = true;
  @Input() isMonitoring = false;
  @Input() isCheck = false;
  @Input() workflow: any | undefined;
  @Input() isNodeSelector = true;
  @Input() isNodeParameters = true;
  @Input() nodes?: NodeModel[];
  @Input() idGraph: string = 'myJointPaper';

  //DOMAIN
  public selectedNode: NodeClass | undefined;
  //END DOMAIN

  public graph?: joint.dia.Graph;
  public paper?: joint.dia.Paper;
  public panZoom?: any;
  public destroyingComponent = false;
  public isDragged = false;
  isSelectionGoalMode = false;
  selectedGoalNode: NodeClass | undefined;
  isOnlyCanvas = false;
  copiesList: CopyModel[] = [] as any[];
  isSmallScreen: boolean = false;
  workflowInstance: WorkflowInstance | undefined;
  NodeValidator = new helper.NodesValidator();

  public selectedElement?: joint.dia.Element;
  private lastSelectedElement?: joint.dia.Element;

  private createNewNodes = inject(CreateNewNodesService);
  private monitoringTooltip = inject(MonitoringTooltip);
  private cdr = inject(ChangeDetectorRef);

  constructor(
    private toastService: ToastService,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private routing: Router,
    private branchService: BranchVisibilityService,
    private workflowState: WorkflowStateService,
    private registry: NodeInspectorRegistry,
  ) {
    effect(() => {
      const highlightedId = this.workflowState.highlightedNodeId();
      if (highlightedId) {
        const node = this.workflow.findNode(highlightedId);
        if (node) {
          this.removeHighlight();
          this.highlightSelectedGoalNode(node, '#ff851b');
        }
      } else {
        this.removeHighlight();
      }
    });
  }

  @HostListener('window:resize', ['$event'])
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }

  ngOnInit() {
    this.checkScreenSize();
    try {
      if (this.config.data && this.config.data.nodes) {
        this.nodes = this.config.data.nodes;
        this.isMonitoring = true;
        this.isEditable = false;
        if (this.config.data.workflowInstance)
          this.workflowInstance = this.config.data.workflowInstance;
        this.workflow = new WorkflowClass('show-id', 'Only Show Workflow', WorkflowType.DRIP);
        this.isOnlyCanvas = true;
      }
      this.graph = new joint.dia.Graph();
      this.initWorkflow();
      this.draw(this.isMonitoring);

      /*this.branchService.branchVisibility$.subscribe(({ nodeId, branch, visible }) => {
        const element = this.graph!.getElements().find((el) => {
          return el.attributes['data']?.original === nodeId;
        });
        console.log('JOINT JS VISBBB', element, branch, visible);
        if (element) {
          element.portProp(
            `out${branch}`,
            'attrs/.port-body/visibility',
            visible ? 'visible' : 'hidden',
          );
        }
      });*/
    } catch (error) {
      if (error instanceof NodeNotFoundError || error instanceof InvalidNodeTypeError) {
        this.toastService.showError('Error al iniciar workflow', error.message);
        console.error(error.message);
      } else {
        console.error(error, 'Unexpected error on init');
      }
    }
  }

  ngAfterViewInit() {
    this.setPaper();
    this.svgPanZoom();
    if (this.workflowInstance && this.workflowInstance.nodeId) {
      const highlightGoalNode = this.workflow.findNode(this.workflowInstance.nodeId);
      if (highlightGoalNode) {
        this.highlightSelectedGoalNode(highlightGoalNode, '#6366f1');
      }
    }
    this.paperActions();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isEditable'] && !changes['isEditable'].firstChange) {
      if (
        this.isEditable &&
        !(
          changes['isEditable'].previousValue == true && changes['isEditable'].currentValue == false
        )
      ) {
        this.paperActions();
      } else if (
        changes['isEditable'].previousValue == true &&
        changes['isEditable'].currentValue == false
      ) {
        this.disableTools();
      }
    }
    if (changes['nodes']) {
    }
    if (changes['nodes'] && !changes['nodes'].firstChange && !this.isDragged) {
      //CHANGE MODE MONITORING TO EDIT
      //TODO: COULD CLEAN THE TWO TYPES OF NODES
      this.destroyingComponent = true;
      this.clearGraph();
      this.workflow.nodes.length = 0;
      this.initWorkflow();
      this.draw();
      this.destroyingComponent = false;
    }
  }

  clearGraph() {
    if (this.graph) {
      this.graph.clear();
    }
  }

  closeModalAndRedirect() {
    this.ref.close();
    setTimeout(() => {
      this.routing.navigate(['/campaigns/edit/', this.workflowInstance!.workflowId], {
        queryParamsHandling: 'preserve',
      });
    }, 300);
  }

  initWorkflow() {
    //DOMAIN
    //SHOULD BE IMPROVED, SOLVE NodeModel and NodeClass => Unify to NodeClass

    if (this.workflow.nodes.length !== 0 && !this.isEditable) {
      if (this.nodes) {
        this.nodes.forEach((uiNode: any, index: number) => {
          const domainNode = (this.workflow as WorkflowClass).findNode(uiNode.nodeId);
          if (domainNode) {
            domainNode.orderNode =
              typeof uiNode.position === 'number' && !isNaN(uiNode.position)
                ? uiNode.position
                : index + 1;
          }
        });
      }
    } else {
      if (!this.nodes || this.nodes?.length === 0) {
        this.nodes = DEFAULT_NODES();
      }
      if (this.nodes[0].parameters['name']) {
        this.workflow.nodes.length = 0;
        this.nodes.forEach((node) => {
          let newDNode = NodeFactory.parseAndCreateNode(node);
          if (newDNode) {
            this.workflow.addNode(newDNode);
          } else {
            throw new Error('Could not parse info');
          }
        });
        this.workflow.assignParentNodes();
      }
      //END DOMAIN
    }
    (this.workflow as WorkflowClass).orderNodes();
  }

  getGraph() {
    return {
      graph: this.graph,
      paper: this.paper,
      selectedElement: this.selectedElement,
    };
  }

  draw(isMonitoring?: boolean) {
    let elements: joint.dia.Element[] = [];
    (this.workflow as WorkflowClass).orderNodes();

    if (isMonitoring !== undefined) {
      this.isMonitoring = isMonitoring;
      this.isEditable = !isMonitoring;
    }
    // Crear nodos
    elements = this.createNodes(elements);

    // Connect Links between nodes
    this.linkNodes(elements);

    this.updateNodes();
  }

  get inspectorMode(): 'edit' | 'preview' {
    return this.isEditable ? 'edit' : 'preview';
  }

  createNodes(
    elements: joint.dia.Element<joint.dia.Element.Attributes, joint.dia.ModelSetOptions>[],
  ) {
    (this.workflow as WorkflowClass).nodes!.forEach((node) => {
      const element = this.createNewNodes.createNode(node.type, node.position.x, node.position.y, {
        ...node.config,
        childrens: node.childrenNodes,
        original: node.id,
        parent: node.parentNodes,
      })!;
      elements.push(element);
      this.graph!.addCell(element);

      if (!this.isEditable && node.orderNode !== undefined && !this.isCheck) {
        const buble = new joint.shapes.standard.Circle();

        if (
          node.type === NodeType.Conditional ||
          node.type === NodeType.ConditionalSegments ||
          node.type === NodeType.Experiment
        ) {
          buble.position(node.position.x - 50, node.position.y - 5);
        } else {
          buble.position(node.position.x - 10, node.position.y - 5);
        }

        buble.resize(20, 20);
        buble.attr({
          body: {
            fill: '#e1e1e1',
            stroke: '#e1e1e1',
            strokeWidth: 5,
          },

          label: {
            textWrap: {
              text: node.orderNode.toString(),
              breakWords: true,
            },
            lineHeight: '0em',
            alignmentBaseline: 'middle',
            textAnchor: 'middle',
            fill: '#414141',
            refX: 0.5,
            refY: 0.5,
          },
        });
        elements.push(buble);
        this.graph!.addCell(buble);
      }

      if (!this.isEditable && this.isMonitoring) {
        this.setTooltip(node, node.position);
      }
    });

    return elements;
  }

  linkNodes(
    elements: joint.dia.Element<joint.dia.Element.Attributes, joint.dia.ModelSetOptions>[],
  ) {
    (this.workflow as WorkflowClass).nodes.forEach((node) => {
      const sourceElement = elements.find((el) => {
        if (el.attributes['data']) return el.attributes['data'].original === node.id;
        else return null;
      });
      if (
        sourceElement &&
        (node.type === NodeType.PaylinkNotificationStatus ||
          node.type === NodeType.Experiment ||
          node.type === NodeType.ConditionalSegments)
      ) {
        const trueTargetElement = elements.find(
          (el) => (el.attributes['data']?.original || 'none') === node.config?.['cases']?.true,
        );
        const falseTargetElement = elements.find(
          (el) => (el.attributes['data']?.original || 'none') === node.config?.['cases']?.false,
        );

        if (trueTargetElement) {
          const trueLink = this.createNewNodes.createLink(
            sourceElement,
            trueTargetElement,
            'right',
            'top',
          );
          this.graph!.addCell(trueLink);
        }

        if (falseTargetElement) {
          const falseLink = this.createNewNodes.createLink(
            sourceElement,
            falseTargetElement,
            'bottom',
            'top',
          );
          this.graph!.addCell(falseLink);
        }
      } else if (sourceElement) {
        node.childrenNodes.forEach((childId) => {
          const targetElement = elements.find((el) => {
            if (el.attributes['data']) return el.attributes['data'].original === childId;
            else return null;
          });
          try {
            if (targetElement) {
              //DOMAIN
              let actualDNode = this.workflow.findNode(node.id);
              if (actualDNode?.childrenNodes.length == 1) {
                let targetDNode = this.workflow.findNode(actualDNode?.childrenNodes[0]);
                let targetDID = targetDNode?.id;
                let actualDID = actualDNode?.id;
                const link = this.createNewNodes.createLink(
                  sourceElement,
                  targetElement,
                  this.checkparent(sourceElement.id, this.graph!.getLinks()) ? 'right' : 'bottom',
                  'top',
                  { actualDID, targetDID },
                );
                //END DOMAIN
                this.graph!.addCell(link);
              } else {
                console.log('Has more than one child');
              }
            }
          } catch (error) {
            if (error instanceof NodeNotFoundError || error instanceof InvalidNodeTypeError) {
              this.toastService.showError('Error al linkear elementos del workflow', error.message);
              console.error(error.message);
            } else {
              this.toastService.showError(
                'Error al linkear elementos del workflow',
                (error as Error).message,
              );
              console.error(error, 'Unexpected error on linking nodes');
            }
          }
        });
      }
    });
  }

  checkparent(parent: any, links: any): boolean {
    let ids = [];
    if (links.length > 0) {
      ids = links.map((l: any) => l.attributes.source.id);
      return ids.some((id: any) => id === parent);
    }
    return false;
  }

  setTooltip(node: any, position: { x: number; y: number }) {
    if (!Array.isArray(this.nodes) || this.nodes.length === 0) {
      console.error('No valid nodes available');
      return;
    }

    const extractedExtras = this.nodes.map((n) => n.parameters?.extra).filter((extra) => extra);
    if (extractedExtras.length === 0) {
      console.log('No extra parameters found');
      return;
    }

    const extractedNodeParams = extractedExtras.find((extra: any) => extra.id === node.id);
    if (extractedNodeParams) {
      this.monitoringTooltip.createMonitoringTemplate(node, extractedNodeParams).subscribe({
        next: (nodeText) => {
          const tooltip = new joint.shapes.standard.Rectangle({
            position: { x: position.x + 120, y: position.y + 35 },
            markup: [
              {
                tagName: 'rect',
                selector: 'body',
              },
              {
                tagName: 'text',
                selector: 'label',
              },
            ],
            attrs: {
              body: {
                fill: 'black',
                stroke: 'none',
                strokeWidth: 5,
              },
              label: {
                text: nodeText,
                textAnchor: 'start',
              },
            },
          });

          this.graph!.addCell(tooltip);

          if (this.workflowInstance && this.workflowInstance.nodeId === node.id) {
            const tooltip = new joint.shapes.standard.Rectangle({
              position: { x: position.x - 300, y: position.y + 35 },
              markup: [
                {
                  tagName: 'rect',
                  selector: 'body',
                },
                {
                  tagName: 'text',
                  selector: 'label',
                },
              ],
              attrs: {
                body: {
                  fill: 'black',
                  stroke: 'none',
                  strokeWidth: 5,
                },
                label: {
                  text: 'Expediente actualmente en nodo -->',
                  textAnchor: 'start',
                },
              },
            });

            this.graph!.addCell(tooltip);
          }
        },
        error: (err) => {
          this.toastService.showError('Error', 'Failed to load tooltip text');
          console.error('Failed to load tooltip text', err);
        },
      });
    } else {
      console.log('No matching extra parameters found for node id:', node.id);
    }
  }

  setDraggedNode(node: any) {
    this.isDragged = true;
    this.isSelectionGoalMode = false;
    this.removeHighlight();
    this.resetLastSelectedElementStyle();
    this.selectedElement = node;

    //DOMAIN
    const nodeId = node.attributes['data'].original;

    const eventNode: EventNode = {
      type: 'dragged',
      nodeId: node.attributes.data.original,
      nodeData: {
        ...node.attributes.data,
        position: node.position(),
      },
    };
    const type = node.attributes.data.name as NodeType;
    const pos = node.position();

    const domainNode = NodeFactory.createNode(type, pos.x, pos.y, nodeId);
    if (!domainNode) {
      throw new Error('Failed to create domain node');
    }

    if ((domainNode as any).initNodeConfig) {
      (domainNode as any).initNodeConfig();
    }

    this.workflowState.addOrUpdateNode(domainNode!);

    this.selectedNode = this.workflow.findNode(nodeId);
    this.workflowState.setSelectedNode(eventNode);

    //END DOMAIN
    this.checkNode(this.selectedElement, this.selectedNode!);
    this.applySelectedElementStyle();
    this.lastSelectedElement = this.selectedElement;
    this.setNewNodes();
  }

  resetLastSelectedElementStyle() {
    //DOMAIN
    this.selectedNode = undefined;
    //this.workflowState.setSelectedNode(null);

    //DOMAIN

    if (this.lastSelectedElement) {
      this.lastSelectedElement.attr({
        body: {
          strokeDasharray: '0',
        },
        rect: {
          strokeDasharray: '0',
        },
      });
    }
  }

  applySelectedElementStyle() {
    if (this.selectedElement) {
      this.selectedElement.attr({
        body: {
          strokeDasharray: '5,2', // Estilo punteado
        },
        rect: {
          strokeDasharray: '5,2',
        },
      });
    }
  }

  setPaper() {
    this.paper = new joint.dia.Paper({
      el: document.getElementById(this.idGraph)!,
      model: this.graph,
      ...PAPER_CONFIG,
      interactive: () => {
        if (!this.isEditable) return { elementMove: false };
        return true;
      },
      validateConnection: (cellViewS, magnetS, cellViewT, magnetT) => {
        if (magnetS && magnetS.getAttribute('port-group') === 'top') {
          return false;
        }

        if (cellViewS === cellViewT) {
          return false;
        }

        if (magnetT && magnetT.getAttribute('port-group') === 'top') {
          if (
            cellViewT.model.attributes['data'].name === 'end' ||
            cellViewT.model.attributes['data'].name === 'assignCampaign'
          ) {
          } else {
            const inboundLinks = this.graph!.getConnectedLinks(cellViewT.model, {
              inbound: true,
            });

            if (inboundLinks.length >= 1) {
              return false;
            }
          }

          return true;
        }

        return false;
      },
    });
  }

  paperActions() {
    this.elementsTools();
    this.linksTools();
  }

  checkNode(elementSelected: any, selectedNode: NodeClass) {
    if (!this.isEditable) return;

    this.graph!.getElements().forEach((element) => {
      const nodeId = element.attributes['data']?.original;
      if (!nodeId) return;

      const nodeFromState = this.workflowState.getNodeSignal(nodeId)();

      const isNewNode = !!(nodeFromState && this.registry.get(nodeFromState.type));

      let hasErrors = false;

      //Check if new (registry) or old
      if (isNewNode) {
        hasErrors = nodeFromState.isEmptyConfig() || nodeFromState.validate().length > 0;
      } else {
        const nodeLegacy = (this.workflow as WorkflowClass).findNode(nodeId);
        if (nodeLegacy) {
          hasErrors = nodeLegacy.isEmptyConfig() || nodeLegacy.validate().length > 0;
        }
      }

      if (hasErrors) {
        this.NodeValidator.showError(element);
      } else {
        this.NodeValidator.hideError(element, this.workflow as WorkflowClass);
      }
    });

    this.cdr.detectChanges();
  }

  checkScreenSize() {
    this.isSmallScreen = window.innerWidth <= 1024;
  }

  updateNodes() {
    this.graph!.getElements().forEach((element) => {
      this.setCoordinates(element);
      this.checkNode(element, this.selectedNode!);
      //this.setNodeNumber(element);
      this.cdr.detectChanges();
    });
  }

  handleHighlightGoalNode() {
    if (this.selectedNode && this.selectedNode.type == NodeType.Conditional) {
      //Highlight node target from Conditional Node if exists
      const targetNode = (this.selectedNode.config as ConditionalConfig).targetNodeId;
      if (targetNode) {
        const highlightGoalNode = this.workflow.findNode(targetNode);
        if (highlightGoalNode) {
          this.highlightSelectedGoalNode(highlightGoalNode, '#ff851b');
        }
      }
    }
  }

  elementsTools() {
    this.paper!.on('element:mouseenter', (elementView) => {
      if (!this.isEditable) return;

      if (this.isSelectionGoalMode) {
        elementView.$el.css('cursor', 'copy');
      }

      if (
        this.workflow.getNode(elementView.model.attributes['data']?.original || 'none').type ===
        NodeType.Start
      )
        return;

      if (this.isNodeSelector && !this.isSelectionGoalMode) {
        const removeButton = new joint.elementTools.Remove({
          useModelGeometry: true,
          y: '10%',
          x:
            elementView.model.attributes['data'].name === 'paylinkNotificationStatus'
              ? '-18%'
              : '10%',
          scale: 1.5,
        });

        const toolsView = new joint.dia.ToolsView({
          tools: [removeButton],
        });

        elementView.addTools(toolsView);
        elementView.showTools();
      }
    });

    this.paper!.on('element:mouseleave', (elementView) => {
      if (!this.isEditable) return;

      elementView.$el.css('cursor', 'default');
      elementView.hideTools();

      this.checkNode(elementView.model, this.selectedNode!);
    });

    this.paper!.on('cell:pointerdown', (cellView, evt) => {
      //Selection of Goal node in conditional node

      if (this.isSelectionGoalMode) {
        this.handleSelectionNodeGoal(evt, cellView);
      } else {
        this.removeHighlight();
        this.resetLastSelectedElementStyle();

        if (cellView.model instanceof joint.dia.Element) {
          this.selectedElement = cellView.model;
          //DOMAIN
          const nodeId = cellView.model.attributes['data']?.original || null;

          // OLD inspector
          this.selectedNode = nodeId ? this.workflow.findNode(nodeId) : undefined;

          // NEW inspector (bridge)
          //this.workflowState.setSelectedNode(nodeId);

          if (!nodeId) return;

          const event: EventNode = {
            type: 'existing',
            nodeId,
            nodeData: cellView.model.attributes['data'],
          };
          this.workflowState.setSelectedNode(event);

          this.handleHighlightGoalNode();
          //END DOMAIN
          this.checkNode(cellView.model, this.selectedNode!);
          this.applySelectedElementStyle();
        }

        this.lastSelectedElement = this.selectedElement;
      }
    });

    //TODO: MOVE TO SERVICE --> LOGIC TO UPDATE THE NODES CONDITIONAL CASES WHEN LINKS ARE CHANGED
    //LINKING ON TARGET
    this.graph!.on('change:source change:target', (link) => {
      if (!this.isEditable) return;

      const sourceId = link.get('source').id;
      const targetId = link.get('target').id;
      const source = link.get('source');

      if (sourceId && targetId) {
        const sourceElement = this.graph!.getCell(sourceId);
        const targetElement = this.graph!.getCell(targetId);

        //DOMAIN
        let data = sourceElement?.get('data');
        try {
          //AFTER IS LINKED
          this.paper!.on('link:connect', ($event) => {
            const sourceElementConnected = this.graph!.getCell(
              $event.model.attributes['source'].id,
            );
            const targetElementConnected = this.graph!.getCell(
              $event.model.attributes['target'].id,
            );

            const oldChildrenNode = (this.workflow as WorkflowClass).findNode(
              sourceElementConnected.attributes['data'].original,
            );

            if (
              oldChildrenNode &&
              !(
                oldChildrenNode.type === NodeType.Conditional ||
                oldChildrenNode.type === NodeType.ConditionalSegments ||
                oldChildrenNode.type === NodeType.Experiment
              )
            ) {
              oldChildrenNode.childrenNodes.forEach((id) => {
                (this.workflow as WorkflowClass).findNode(id)?.removeAllParents();
              });

              oldChildrenNode?.removeAllChilds();
            }

            if (
              sourceElementConnected.attributes['data'] &&
              targetElementConnected.attributes['data']
            ) {
              const actualDID = sourceElementConnected.attributes['data'].original;
              const targetDID = targetElementConnected.attributes['data'].original;
              this.handleConidtionalLinking(sourceElement, targetElement, data, source);

              //EVENT IS CALLED MULTIPLE TIMES IF ARROW IS DRAGGED IN AND OUT
              (this.workflow as WorkflowClass).linkNodes(actualDID, targetDID);
              this.workflowState.loadWorkflow(this.workflow);
            }
          });
        } catch (error) {
          if (error instanceof NodeNotFoundError || error instanceof InvalidNodeTypeError) {
            this.toastService.showError('Error al eliminar elemento de workflow', error.message);
            console.error(error.message);
          } else {
            this.toastService.showError(
              'Error al eliminar elemento de workflow',
              (error as Error).message,
            );
            console.error(error, 'Unexpected error on remove element');
          }
        }
        //END DOMAIN
      }
    });
  }

  handleConidtionalLinking(
    sourceElement: joint.dia.Cell<joint.dia.Cell.Attributes, joint.dia.ModelSetOptions>,
    targetElement: joint.dia.Cell<joint.dia.Cell.Attributes, joint.dia.ModelSetOptions>,
    data: any,
    source: any,
  ) {
    if (
      sourceElement?.attributes['nodeType'] === 'conditional' ||
      sourceElement?.attributes['nodeType'] === 'customerCaseSegments'
    ) {
      sourceElement?.attributes?.['ports'].items.find((port: any) => {
        if (port.id === source.port) {
          if (port?.group === 'right') {
            //NODE CONDITIONAL DOMAIN LOGIC - TRUE
            this.workflow.findNode(
              sourceElement.attributes['data']?.original || 'none',
            ).config.cases.true = targetElement?.attributes?.['data'].original;
            data.cases.true = targetElement?.attributes?.['data'].original;
          }
          if (port?.group === 'bottom') {
            //NODE CONDITIONAL DOMAIN LOGIC - FALSE
            const findedNode = this.workflow.findNode(
              sourceElement.attributes['data']?.original || 'none',
            );
            if (findedNode && findedNode.config) {
              findedNode.config.cases.false = targetElement?.attributes?.['data'].original;
              data.cases.false = targetElement?.attributes?.['data'].original;
            }
          }
        }
        sourceElement?.set('data', data);
      });
    } else if (sourceElement?.attributes['nodeType'] == 'experiment') {
      const sourceNodeId = sourceElement.attributes['data']?.original;
      const targetNodeId = targetElement.attributes['data']?.original;
      console.log('SOURCE AND TARGET', sourceNodeId, targetNodeId);
      if (!sourceNodeId || !targetNodeId) return;

      const ports = sourceElement.attributes?.['ports'];
      const items = ports?.items;

      const port = items?.find((p: any) => p.id === source.port);
      console.log('PORT EXPERIMENT', port);
      if (!port) return;

      const portGroup = port.group?.toString().trim().toLowerCase();

      let caseKey: 'true' | 'false' | null = null;

      if (portGroup === 'right') caseKey = 'true';
      if (portGroup === 'bottom') caseKey = 'false';

      const node = this.workflowState.getNodeSignal(sourceNodeId)();
      const existingCases = node?.config?.['cases'] ?? { true: null, false: null };

      // 🔹 Parallel domain update (IMMUTABLE)
      this.workflowState.updateNodeConfig(sourceNodeId, {
        cases: {
          ...existingCases,
          [caseKey!]: targetNodeId,
        },
      });
    }
  }

  disableTools(): void {
    // Remove event listeners
    this.paper!.off('link:mouseenter');
    this.paper!.off('link:mouseleave');

    // Remove tools from all links
    this.graph!.getLinks().forEach((link) => {
      const linkView = this.paper!.findViewByModel(link);
      if (linkView) {
        linkView.removeTools();
      }
    });
  }

  linksTools() {
    const sourceArrowheadTool = new joint.linkTools.SourceArrowhead();
    const targetArrowheadTool = new joint.linkTools.TargetArrowhead();
    const removeButton = new joint.linkTools.Remove({
      distance: 30,
    });

    const toolsView = new joint.dia.ToolsView({
      tools: [sourceArrowheadTool, targetArrowheadTool, removeButton],
    });

    if (this.isNodeSelector && this.isEditable) {
      this.paper!.on('link:mouseenter', (linkView) => linkView.addTools(toolsView));
      this.paper!.on('link:mouseleave', (linkView) => linkView.removeTools());
      this.graph!.on('remove', (cellView) => {
        if (!this.isEditable) return;

        //DOMAIN - REMOVE
        const elementsGraph = this.graph!.getElements();
        //Handle remove node on highlight mode
        this.removeHighlight();
        this.isSelectionGoalMode = false;

        try {
          if (!this.destroyingComponent) {
            if (
              cellView.attributes.source &&
              cellView.attributes.type === 'standard.Link' &&
              cellView.attributes.target.id
            ) {
              //UNLINK NODES WHEN DELETE LINK
              this.unlinkOnDeleteLink(elementsGraph, cellView);
            } else if (cellView.attributes.type !== 'standard.Link') {
              //UNLINK WHEN CELLVIEW IS NODE
              this.unlinkOnDeleteNode(cellView);
            }
          }
        } catch (error) {
          if (error instanceof NodeNotFoundError || error instanceof InvalidNodeTypeError) {
            //this.toastService.showError('Error removing', error.message);
            console.error(error.message);
          } else {
            console.error(error, 'Unexpected error');
          }
        }
        //END DOMAIN
      });
    }
  }

  unlinkOnDeleteLink(
    elementsGraph: joint.dia.Element<joint.dia.Element.Attributes, joint.dia.ModelSetOptions>[],
    cellView: any,
  ) {
    const sourceElementLink = elementsGraph.find((el) => el.id === cellView.attributes.source.id);
    const targetElementLink = elementsGraph.find((el) => el.id === cellView.attributes.target.id);
    let parentDNode = sourceElementLink?.attributes['data']?.original || 'none';
    let childDNode = targetElementLink?.attributes['data']?.original || 'none';

    // Bridge to State Service
    const wf = this.workflowState.workflow();
    if (wf) {
      const clone = new WorkflowClass((wf as any).id, (wf as any).name, (wf as any).type);
      clone.status = (wf as any).status;
      clone.nodes = (wf.nodes || []).slice();
      clone.unlinkNodes(parentDNode, childDNode);
      this.workflowState.loadWorkflow(clone);
    }

    (this.workflow as WorkflowClass).unlinkNodes(parentDNode, childDNode);
    this.selectedElement = undefined;
    this.selectedNode = undefined;
    //this.workflowState.setSelectedNode(null);
  }

  unlinkOnDeleteNode(cellView: any) {
    this.graph?.removeCells(cellView);
    if (!this.isEditable) return;

    const nodeId = cellView.attributes['data']?.original;
    if (!nodeId) return;

    // Bridge to State Service
    this.workflowState.removeNode(nodeId);

    // Legacy sync
    if (this.selectedNode && this.selectedNode.id === nodeId) {
      (this.workflow as WorkflowClass).removeNode(this.selectedNode.id);
    } else {
      (this.workflow as WorkflowClass).removeNode(nodeId);
    }
  }

  svgPanZoom() {
    this.panZoom = svgPanZoom(this.paper!.svg, ZOOM_CONFIG(this.paper!));
    this.graph!.getElements().length < 5 ? this.panZoom.zoom(0.4) : this.panZoom.zoom(0.8);
    this.paper!.on('blank:pointerdown', () => {
      document.body.style.cursor = 'auto';
      this.panZoom.enablePan();
    });

    this.paper!.on('blank:pointerup', () => {
      document.body.style.cursor = 'auto';
      this.panZoom.disablePan();
    });

    const controls = document.getElementById('svg-pan-zoom-controls') as HTMLElement;
    controls.setAttribute('style', 'display: none !important');
  }

  handleNodeChange({ id, newAttributes }: { id: string; newAttributes: any }) {
    let cell = this.graph!.getCell(id);
    if (cell) {
      this.setNodeData(cell, newAttributes);
      this.updateNodes();
      this.setCoordinates(cell);
      this.setNewNodes();
      this.cdr.detectChanges();
    }
  }

  setCoordinates(cell: any) {
    let diagram = {
      coordinates: {
        x: Math.round(cell.get('position').x),
        y: Math.round(cell.get('position').y),
      },
    };
    cell.set('diagram', diagram);
  }

  setNodeData(cell: any, newAttributes: any) {
    let data = cell.get('data');
    let cleanNewAttributes = helper.cleanAttributes(newAttributes);
    data = { ...data, ...cleanNewAttributes };
    data = helper.verifyAndCleanParameters(data);
    cell.set('data', data);
  }

  setNewNodes() {
    this.nodesReady.emit(this.nodes);
  }

  ngOnDestroy(): void {
    this.destroyingComponent = true;
    this.graph!.clear();
    this.paper!.remove();
    this.destroyingComponent = false;
  }

  resetGraph(): void {
    this.destroyingComponent = true;
    this.graph!.clear();
    this.destroyingComponent = false;
  }

  highlightGoalNodes() {
    //Called method from event thrown on node-inspector by conditional node
    const parentNodesWithCopyIds = (
      this.workflow as WorkflowClass
    ).getParentNodesWithCopyIdsInBranch(this.selectedNode!);

    this.graph!.getElements().forEach((element) => {
      const nodeId = element.attributes['data']?.original || 'none';
      const node = (this.workflow as WorkflowClass).findNode(nodeId);

      if (node && parentNodesWithCopyIds.includes(node)) {
        this.isSelectionGoalMode = true;

        const elementView = this.paper!.findViewByModel(element);
        joint.highlighters.mask.add(elementView, { selector: 'root' }, 'my-element-highlight', {
          deep: true,
          attrs: {
            stroke: '#ff851b',
            'stroke-width': 5,
            [`stroke-dasharray`]: '5,2',
          },
        });
      }
    });
  }

  highlightSelectedGoalNode(node: NodeClass, color: string) {
    const element = this.graph!.getElements().find((element) => {
      if (element.attributes['data']) return element.attributes['data']?.original === node.id;
      else return null;
    });

    if (element) {
      const elementView = this.paper!.findViewByModel(element);
      if (elementView instanceof joint.dia.ElementView) {
        joint.highlighters.mask.add(elementView, { selector: 'root' }, 'my-element-highlight', {
          deep: true,
          attrs: {
            stroke: color,
            'stroke-width': 7,
          },
        });
      }
    }
  }

  removeHighlight() {
    joint.highlighters.mask.removeAll(this.paper!);
  }

  zoomToNode(position: { x: number; y: number }) {
    if (this.panZoom) {
      const { x, y } = position;

      const container = this.panZoom.getSizes();
      const zoomLevel = 2;

      const pan = {
        x: -x * zoomLevel + container.width / 2,
        y: -y * zoomLevel + container.height / 2,
      };

      this.panZoom.zoom(zoomLevel);
      this.panZoom.pan(pan);
    }
  }

  handleSelectionNodeGoal(evt: any, cellView: any) {
    const parentNodesWithCopyIds = (
      this.workflow as WorkflowClass
    ).getParentNodesWithCopyIdsInBranch(this.selectedNode!);

    const clickedNode = this.workflow.findNode(
      cellView.model.attributes['data']?.original || 'none',
    );

    const isAvailableToClick = parentNodesWithCopyIds.some((node) => node.id === clickedNode.id);

    if (hascopyIds(clickedNode.config) && isAvailableToClick) {
      evt.stopPropagation();
      this.selectedGoalNode = this.workflow.findNode(
        cellView.model.attributes['data']?.original || 'none',
      );
      this.selectedNode = this.workflow.findNode(
        this.lastSelectedElement?.attributes['data']?.original || 'none',
      );

      if (this.selectedGoalNode) {
        //Add target node to conditional node
        (this.selectedNode?.config as ConditionalConfig).targetNodeId = this.selectedGoalNode?.id;
        if (this.selectedNode) {
          this.workflowState.addOrUpdateNode(this.selectedNode);
        }
      }

      this.removeHighlight();
      this.highlightSelectedGoalNode(this.selectedGoalNode!, '#ff851b');

      this.isSelectionGoalMode = false;
    } else {
      this.toastService.showInfo('Nodo no indicado', 'Debe seleccionar un nodo adecuado');
    }
  }

  protected readonly NodeType = NodeType;
}
